import { Icon } from "@nulogy/components";
import { sidebarExpandButtonWidth } from "components/pages/schedule/sidebarSizes";
import React from "react";
import styled from "styled-components";

const ExpanderButton = styled.button(({ theme }) => ({
  "& > svg": {
    marginLeft: "-3px",
  },
  "&:hover": {
    backgroundColor: theme.colors.lightBlue,
  },
  alignSelf: "stretch",
  backgroundColor: "#fff",
  border: `1px solid ${theme.colors.lightGrey}`,
  boxShadow: "none",
  cursor: "pointer",
  display: "block",
  height: "100%",
  margin: 0,
  outline: "none",
  position: "fixed",
  right: 0,
  top: 0,
  width: sidebarExpandButtonWidth,
  zIndex: 5,
}));

export default function SidebarExpander({ onToggleSidebar }) {
  return (
    <ExpanderButton className="spec-expand-sidebar" onClick={onToggleSidebar} type="button">
      <Icon icon="leftArrow" />
    </ExpanderButton>
  );
}
